module.exports = __webpack_public_path__ + "static/media/godOfMars-2.50fa9855.png";